import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import moment from 'moment';

export default {
  data: function () {
    return { 
      customerFeedbackList: [],
      marketingMetricsList: [],
      ordersAndRegistrationsList: [],
      totalRegisteredDevices: 'N/A',
      cumulativeRegisteredDevices: [],
      registeredDeviceCategories: [],
      lowLeakAlerts: 'N/A',
      Repairs: 'N/A',
      damageCausingRepairs: 'N/A',
      damageCausingRepairsFixed: 'N/A',
      leakCategories: [],
      totalRepairs: [],
      workOrderClaimSavings: 'N/A',
      workOrderClaimSavingsFixed: 'N/A',
      costOfProgramme: 'N/A',
      lastInvoiceMonth: null,
      currentDate: moment(),
      dateFrom: 'N/A',
      dateTo: 'N/A',
      tenantSelection: null,
      applyBtnDisabled: false,
      isLoadingCustomerFeedbackList: true,
      isLoadingMarketingMetricsList: true,
      isLoadingOrdersAndRegistrationsList: true,
      isLoadingLowLeakAlerts: true,
      isLoadingRepairs: true,
      isLoadingDamageCausingRepairs: true,
      isLoadingLeakCategoriesList: true,
      isLoadingMonthlyRegistrationsList: true,
      isLoadingWorkOrderClaimSavings: true,
      isLoadingCostOfProgramme: true,
      currencyCode: ''
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD-MMM-YYYY');
    },
    currency: function (amount, localCurrency) {
      return amount != 'N/A' ? `${localCurrency} ${new Intl.NumberFormat('en-UK').format(amount)}` : amount;
    }
  },
  mounted () {
    // Fetch CostOfProgramme first, then fetch DamageCausingRepairs(fixed) after lastInvoiceMonth is available
    this.fetchCostOfProgrammeData().then(() => {
      this.fetchDamageCausingRepairsData(true)
    })
    this.fetchWorkOrderClaimSavingsData(false)
    this.fetchLeakCategoriesData()
    this.fetchDamageCausingRepairsData(false)
    this.fetchRepairsData()
    this.fetchLowLeakAlertsData()
    this.fetchCustomerFeedbackData()
    this.fetchMarketingMetricsData()
    this.fetchOrdersAndRegistrationsData()
    this.fetchMonthlyRegistrationsData()
  },
  methods: {
    loading(){
      this.isLoadingCustomerFeedbackList = true,
      this.isLoadingMarketingMetricsList = true,
      this.isLoadingOrdersAndRegistrationsList = true,
      this.isLoadingLowLeakAlerts = true,
      this.isLoadingRepairs = true,
      this.isLoadingDamageCausingRepairs = true,
      this.isLoadingLeakCategoriesList = true,
      this.isLoadingMonthlyRegistrationsList = true,
      this.isLoadingWorkOrderClaimSavings = true,
      this.isLoadingCostOfProgramme = true
    },
    resetVariables(){
      this.loading();
      this.customerFeedbackList = [],
      this.marketingMetricsList = [],
      this.ordersAndRegistrationsList = [],
      this.totalRegisteredDevices = '',
      this.cumulativeRegisteredDevices = [],
      this.registeredDeviceCategories = [],
      this.lowLeakAlerts = 'N/A';
      this.Repairs = 'N/A';
      this.damageCausingRepairs = 'N/A';
      this.leakCategories = [];
      this.totalRepairs = [];
      this.workOrderClaimSavings = 'N/A';
      this.costOfProgramme = 'N/A';
    },
    applyButtonClicked(){
      this.applyBtnDisabled = true
      this.resetVariables()
      // Fetch CostOfProgramme first, then fetch DamageCausingRepairs(fixed) after lastInvoiceMonth is available
      this.fetchCostOfProgrammeData().then(() => {
        this.fetchDamageCausingRepairsData(true)
      })
      this.fetchWorkOrderClaimSavingsData(false)
      this.fetchLeakCategoriesData()
      this.fetchDamageCausingRepairsData(false)
      this.fetchRepairsData()
      this.fetchLowLeakAlertsData()
      this.fetchCustomerFeedbackData()
      this.fetchMarketingMetricsData()
      this.fetchOrdersAndRegistrationsData()
      this.fetchMonthlyRegistrationsData()
    },
    programme() {
      return this.costOfProgramme !== 'N/A' ? this.costOfProgramme : this.costOfProgramme;
    },
    estimatedClaimsSavings() {
      return (this.workOrderClaimSavings === 'N/A' || isNaN(Math.floor(this.workOrderClaimSavings))) ? this.workOrderClaimSavings : Math.floor(this.workOrderClaimSavings);
    },
    averageCostToClaim() {
      let average = 'N/A';
      if (this.workOrderClaimSavings && (this.workOrderClaimSavings !== ('N/A' || '0') || !isNaN(Math.floor(this.workOrderClaimSavings))) && this.damageCausingRepairsFixed && this.damageCausingRepairsFixed !== 'N/A') {
        average = Math.floor(this.workOrderClaimSavings / this.damageCausingRepairsFixed);
      }
      return average;
    },
    roi() {
      let returnOnInvestment = 'N/A'
      if (this.costOfProgramme && this.costOfProgramme !== 'N/A' && this.workOrderClaimSavings && this.workOrderClaimSavings !== 'N/A') {
        returnOnInvestment = `${Math.floor(((this.workOrderClaimSavings - this.costOfProgramme) / this.costOfProgramme) * 100)}%`;
      }
      return returnOnInvestment
    },
    percentageClaimsInRepairVisits() {
      let percentageClaims = 'N/A';
      if (this.damageCausingRepairs && this.damageCausingRepairs !== 'N/A' && this.repairs && this.repairs.total_repairs) {
        percentageClaims = parseInt(this.damageCausingRepairs, 10) / parseInt(this.repairs.total_repairs, 10) * 100;
        if (percentageClaims % 1 != 0) {
          percentageClaims = `${Number(percentageClaims).toFixed(1)}%`;
        } else {
          percentageClaims = `${percentageClaims}%`;
        }
      }
      return percentageClaims;
    },
    fetchCostOfProgrammeData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      return this.$store.dispatch(APIEvent.FETCH_COST_OF_PROGRAMME, options)
        .then(res => {
          console.log("CostOfProgramme:", res)
          let cost = 'N/A';
          let invoiceDate = null;
          if (res.data.data.length === 1) {
            cost = res.data.data[0].amount;
            invoiceDate = res.data.data[0].last_invoice_month;
          }
          this.costOfProgramme = cost;
          this.lastInvoiceMonth = invoiceDate;
          this.$store.commit('SET_LAST_INVOICE_MONTH', invoiceDate);
          this.isLoadingCostOfProgramme = false;
        })
        .catch(err => {
          let msg = 'The ROI Dashboard can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingCostOfProgramme = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchWorkOrderClaimSavingsData (fixed) {
      let start = fixed ? "2020-01-01" : this.dateFrom;
      let end = fixed ? "2025-12-31" : this.dateTo;
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: start, date_to: end}
      this.$store.dispatch(APIEvent.FETCH_WORK_ORDER_CLAIM_SAVINGS, options)
        .then(res => {
          console.log("workOrderClaimSavingsList:", res)
          let savings = 'N/A';
          if (res.data.data.length === 1) {
            savings = res.data.data[0].total_claim_value;
            this.currencyCode = res.data.data[0].claim_currency;
          }
          if (fixed) {
            this.workOrderClaimSavingsFixed = savings;
          } else {
            this.workOrderClaimSavings = savings;
          }
          this.isLoadingWorkOrderClaimSavings = false;
        })
        .catch(err => {
          let msg = 'The ROI Dashboard can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingWorkOrderClaimSavings = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchLeakCategoriesData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_LEAK_CATEGORIES, options)
        .then(res => {
          console.log("leakCategoriesList:", res)
          let totalLeaks = res.data.data.reduce((a, b) => ({total_repairs: parseInt(a.total_repairs, 10) + parseInt(b.total_repairs, 10)}));
          this.leakCategories = res.data.data.map(x => x.leak_category);
          this.totalRepairs = res.data.data.map(x => x.total_repairs / totalLeaks.total_repairs * 100);
          this.isLoadingLeakCategoriesList = false;
        })
        .catch(err => {
          let msg = 'The Leaks Fixed can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingLeakCategoriesList = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchDamageCausingRepairsData (fixed) {
      let start = fixed ? "2020-01-01" : this.dateFrom;
      const storeLastInvoiceMonth = this.$store.state.lastInvoiceMonth;
      let end = fixed ? (storeLastInvoiceMonth ? moment(storeLastInvoiceMonth).endOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')) : this.dateTo;
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: start, date_to: end}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_DAMAGE_CAUSING_REPAIRS, options)
        .then(res => {
          console.log("damageCausingRepairsList:", res)
          let damage = 'N/A';
          if (res.data.data.length === 1) {
            damage = res.data.data[0].total_damage_causing;
          }
          if (fixed) {
            this.damageCausingRepairsFixed = damage;
          } else {
            this.damageCausingRepairs = damage;
          }
          this.isLoadingDamageCausingRepairs = false;
        })
        .catch(err => {
          let msg = 'The Number of Claims Saved can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingDamageCausingRepairs = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchRepairsData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_REPAIRS, options)
        .then(res => {
          console.log("repairsList:", res)
          let repairs = 'N/A';
          if (res.data.data.length === 1) {
            repairs = res.data.data[0]
          }
          this.repairs = repairs;
          this.isLoadingRepairs = false;
        })
        .catch(err => {
          let msg = 'The Repair Visits can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingRepairs = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchLowLeakAlertsData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_LOW_LEAK_ALERTS, options)
        .then(res => {
          console.log("lowLeakAlertsList:", res)
          let alerts = 'N/A';
          if (res.data.data.length) {
            alerts = res.data.data.reduce((a, b) => ({total_lowleak_alerts: parseInt(a.total_lowleak_alerts, 10) + parseInt(b.total_lowleak_alerts, 10)}));
          }
          this.lowLeakAlerts = alerts;
          this.isLoadingLowLeakAlerts = false;
        })
        .catch(err => {
          let msg = 'The Alerts can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingLowLeakAlerts = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchCustomerFeedbackData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo, fetch_size: '20'}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_CUSTOMER_FEEDBACK, options)
        .then(res => {
          console.log("customerFeedbackList:", res)
          this.customerFeedbackList = res.data.data? res.data.data : []
          this.isLoadingCustomerFeedbackList = false;
        })
        .catch(err => {
          let msg = 'The Customer Feedback can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingCustomerFeedbackList = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchMarketingMetricsData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_MARKETING_METRICS, options)
        .then(res => {
          console.log("marketingMetricsList:", res)
          let metrics = 'N/A';
          if (res.data.data.length) {
            metrics = res.data.data;
          }
          this.marketingMetricsList = metrics;
          this.isLoadingMarketingMetricsList = false;
        })
        .catch(err => {
          let msg = 'The Marketing Metrics can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingMarketingMetricsList = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchOrdersAndRegistrationsData () {
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      //console.log("options:", options)
      this.$store.dispatch(APIEvent.FETCH_ORDERS_AND_REGISTRATIONS, options)
        .then(res => {
          console.log("ordersAndRegistrationsList:", res)
          let orders = 'N/A';
          if (res.data.data.length) {
            orders = res.data.data;
          }
          this.ordersAndRegistrationsList = orders;
          this.isLoadingOrdersAndRegistrationsList = false;
        })
        .catch(err => {
          let msg = 'The Orders and Registrations can not be refreshed. Please check and try again :: '
          msg += err.message
          this.isLoadingOrdersAndRegistrationsList = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    fetchMonthlyRegistrationsData () {
      this.totalRegisteredDevices = [];
      this.cumulativeRegisteredDevices = [];
      this.registeredDeviceCategories = [];
      let options = {tenant_id: this.tenantSelection? this.tenantSelection.id : null, date_from: this.dateFrom, date_to: this.dateTo}
      this.$store.dispatch(APIEvent.FETCH_MONTHLY_REGISTRATIONS, options)
        .then(res => {
          console.log("monthlyRegistrationsList:", res)
          this.totalRegisteredDevices = res.data.data.map(x => x.total_registered_devices);
          this.cumulativeRegisteredDevices = res.data.data.map(x => x.cumulative_registered_devices);
          this.registeredDeviceCategories = res.data.data.map(x => moment(`${x.month}-01`).format('MMM-YY'));
          this.isLoadingMonthlyRegistrationsList = false;
          this.applyBtnDisabled = false
        })
        .catch(err => {
          let msg = 'The Monthly Registrations can not be refreshed. Please check and try again :: '
          msg += err.message
          this.applyBtnDisabled = false
          this.isLoadingMonthlyRegistrationsList = false;
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    }
  }
}
